import { useEffect } from "react";

const BASE_TITLE = "HealthWallet";
const DEFAULT_DESCRIPTION =
  "HealthWallet is a community-powered healthcare funding platform serving Minneapolis-St. Paul. Pre-fund healthcare with crowdfunding wallets, flexible payment schedules, condition-based community funds, and hospital partnerships.";
const PRODUCTION_BASE = "https://healthwallet.ai";

export function usePageTitle(title?: string, description?: string) {
  useEffect(() => {
    if (title) {
      document.title = `${title} | ${BASE_TITLE}`;
    } else {
      document.title = `${BASE_TITLE} — Community-Powered Healthcare Funding`;
    }

    const currentPath = window.location.pathname;

    // Canonical
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", PRODUCTION_BASE + currentPath);

    // og:url
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute("content", PRODUCTION_BASE + currentPath);

    // og:title
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute("content", document.title);

    // twitter:title
    const twTitle = document.querySelector('meta[name="twitter:title"]');
    if (twTitle) twTitle.setAttribute("content", document.title);

    // meta description
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute("content", description || DEFAULT_DESCRIPTION);
    }

    // og:description
    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) {
      ogDesc.setAttribute("content", description || DEFAULT_DESCRIPTION);
    }

    // twitter:description
    const twDesc = document.querySelector('meta[name="twitter:description"]');
    if (twDesc) {
      twDesc.setAttribute("content", description || DEFAULT_DESCRIPTION);
    }

    return () => {
      document.title = `${BASE_TITLE} — Community-Powered Healthcare Funding`;
      if (canonical) canonical.setAttribute("href", PRODUCTION_BASE + "/");
      if (ogUrl) ogUrl.setAttribute("content", PRODUCTION_BASE + "/");
      if (ogTitle) ogTitle.setAttribute("content", `${BASE_TITLE} — Community-Powered Healthcare Funding`);
      if (twTitle) twTitle.setAttribute("content", `${BASE_TITLE} — Community-Powered Healthcare Funding`);
      if (metaDesc) metaDesc.setAttribute("content", DEFAULT_DESCRIPTION);
      if (ogDesc) ogDesc.setAttribute("content", DEFAULT_DESCRIPTION);
      if (twDesc) twDesc.setAttribute("content", DEFAULT_DESCRIPTION);
    };
  }, [title, description]);
}
